import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { AuthProvider, useAuth } from './auth'
import { setTokenProvider } from './services/api'
import { Layout } from './components/layout/Layout'
import { Dashboard } from './pages/Dashboard'
import { ProjectList } from './pages/ProjectList'
import { ProjectDetail } from './pages/ProjectDetail'
import { ChecklistTemplates } from './pages/ChecklistTemplates'
import { ChecklistDetail } from './pages/ChecklistDetail'
import { Documents } from './pages/Documents'
import { Submittals } from './pages/Submittals'
import { IssuesLog } from './pages/IssuesLog'
import { CxReport } from './pages/CxReport'
import { EquipmentDetail } from './pages/EquipmentDetail'
import { MyAssignments } from './pages/MyAssignments'
import { LoginPage } from './pages/LoginPage'
import { LoadingSpinner } from './components/common/LoadingSpinner'
import { AiPanel } from './components/ai/AiPanel'

function AppRoutes() {
  const { isAuthenticated, isLoading, getAccessToken } = useAuth()

  useEffect(() => {
    setTokenProvider(getAccessToken)
  }, [getAccessToken])

  if (isLoading) return <LoadingSpinner fullPage message="Loading CxRunner..." />
  if (!isAuthenticated) return <LoginPage />

  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/my-assignments" element={<MyAssignments />} />
          <Route path="/projects" element={<ProjectList />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/checklists" element={<ChecklistTemplates />} />
          <Route path="/checklists/:id" element={<ChecklistDetail />} />
          <Route path="/equipment/:id" element={<EquipmentDetail />} />
          <Route path="/issues" element={<IssuesLog />} />
          <Route path="/submittals" element={<Submittals />} />
          <Route path="/cx-report" element={<CxReport />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
      <AiPanel />
    </>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  )
}
